import gql from 'graphql-tag';

export const PRODUCT_QUERY =
gql`
  query($first: Int, $page: Int, $name: String, $category_id: Int) {
    product (first: $first, page: $page, name: $name, category_id: $category_id) {
      paginator {
        total
      }
      data {
        product_id
        name
        price
        cover_image {
          file_id
          path
        }
        categories {
          name
        }
        plans {
          period_amount
        }
      }
    }
  }
`;

export const PRODUCT_DETAIL_QUERY =
gql`
  query($product_id: Int!) {
    productDetail (product_id: $product_id) {
      product_id
      name
      summary
      description
      notice
      cover_image {
        file_id
        path
      }
      categories {
        category_id
        name
      }
      plans {
        fanpay_plan_id
        period_count
        period_amount
      }
    }
  }
`;
